<template>
  <span class="quick-actions-dialog-wrapper">
    <QADefaultBtn v-if="isMobile"
      @click="openMenuMobile"
      :btnClass="btnClass"
      :icon-color="iconColor"
      :isActive="isActive"/>

    <v-menu v-else
            v-model="showMenu"
            top 
            offset-y 
            content-class="quick-actions-dialog"
            close-on-click>
      <template v-slot:activator="{ on, attrs }" >
        <QADefaultBtn 
          v-bind="attrs"
          v-on="on"
          :icon-color="iconColor"
          :btnClass="btnClass"
          :isActive="isActive"/>
      </template>

      <QuickActions 
        :actions="actions" 
        :entity="entity" 
        @actionClicked="sendAction" />
    </v-menu>
  </span>
</template>

<script>
import QuickActions from './QuickActions';
import QADefaultBtn from './QADefaultBtn';

export default {
  name: 'QuickActionsDialog',
  components: {
    QuickActions,
    QADefaultBtn
  },
  props: {
    actions: {
      type: Array,
      required: true
    },
    entity: {
      type: Object,
      required: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    btnClass: {
      type: String,
      required: false
    },
    iconColor: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      showMenu: false,
    }
  },
  computed: {
    isActive() {
      return this.showMenu
    }
  },
  methods: {
    openMenuMobile() {
      this.showMenu = true
      this.sendAction({name: 'open-drawer'})
      setTimeout(() => {
        this.showMenu = false
      }, 1000);
    },
    sendAction(action) {
      this.$emit('actionClicked', action)
    }
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.quick-actions-dialog {
  width: 325px;
  border-radius: 8px;
  background-color: $white-color-1;
}
</style>